import Swiper from 'swiper/js/swiper.js'
import ImagesLoaded from 'Imagesloaded'

export default {
  init() {

    const artist = '.artist-product-swiper-container'
    
    const swiper = new Swiper(artist, {
      init: false,
      navigation: {
        nextEl: '.product-nav-next',
        prevEl: '.product-nav-prev',
      },
      loop: false,
      autoplay: {
        delay: 4000,
      },
      speed: 200,
      grabCursor: true,
      slidesPerView: 2,
      spaceBetween: 16,
      breakpoints: {
        768: {
          spaceBetween: 30,
        },

        1440: {
          spaceBetween: 60,
          slidesPerView: 3,
          slidesPerGroup: 3,
          speed: 800
        },

        1640: {
          spaceBetween: 110,
          slidesPerView: 3,
          slidesPerGroup: 3
        }
      }
    });

    ImagesLoaded(artist, () => {
      swiper.init()
    })
    
  },
  finalize() {
  },
}